import { PEILinkExternal } from '../PEILinkExternal';
import styles from '@/styles/PEISectionFooter.module.scss';

export const PEISectionFooter = ({
  textToShow,
  link,
}: {
  textToShow: string | undefined;
  link: string;
}) => {
  return (
    <section className={styles['footer-container']} data-testid='component-footer-id'>
      <PEILinkExternal href={link} target='_blank' className={styles.link} rawHtml={textToShow} />
    </section>
  );
};
